import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';

export const useIsFeatureEnabled = (flag: FeatureFlagKey) => {
  const { isFeatureEnabled } = useStatsig();
  return isFeatureEnabled(flag);
};

export default useIsFeatureEnabled;
